    // @ts-nocheck

    import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
    import { fetchGallerySections, addGallerySection, updateGallerySection } from "../../api/galleryApi";

    export const getGallerySections = createAsyncThunk(
    "gallerySection/getGallerySections",
    async (_, { dispatch, rejectWithValue }) => {
        dispatch(resetStatus());

        try {
        return await fetchGallerySections();
        } catch (error: any) {
        return rejectWithValue(error.message);
        }
    }
    );

    export const createGallerySection = createAsyncThunk(
    "gallerySection/createGallerySection",
    async (newGallerySection: { title: string; description: string; is_active: boolean; image?: string }, { dispatch, rejectWithValue }) => {
        dispatch(resetStatus());

        try {
        return await addGallerySection(newGallerySection);
        } catch (error: any) {
        return rejectWithValue(error.message);
        }
    }
    );

    export const editGallerySection = createAsyncThunk(
    "gallerySection/editGallerySection",
    async (
        {id, data }:any,
        { dispatch, rejectWithValue }
    ) => {
        dispatch(resetStatus());

        try {
            console.log(data,'data');   
            
        return await updateGallerySection(id,data);
        } catch (error: any) {
        return rejectWithValue(error.message);
        }
    }
    );
    // Async thunks for gallerySection operations

    
    // gallerySection Slice

    const gallerySectionSlice = createSlice({
    name: "gallerySection",
    initialState: {
        gallerySections: [] as any[],
        status: null as boolean | null,
        msg: "",
        error: null as string | null,
    },
    reducers: {
        resetStatus(state) {
        state.status = null;
        state.msg = "";
        },
    },
    extraReducers: (builder) => {
        builder
        // Get all gallery sections
        .addCase(getGallerySections.fulfilled, (state, action: PayloadAction<any[]>) => {
            state.status = true;
            console.log(action.payload,'action.payload');
            
            state.gallerySections = action.payload.data;
        })
        .addCase(getGallerySections.rejected, (state, action) => {
            state.status = false;
            state.error = action.payload as string;
        })

        // Create gallery section
        .addCase(createGallerySection.fulfilled, (state, action: PayloadAction<any>) => {
            if (Array.isArray(state.gallerySections)) {
            state.gallerySections.push(action.payload);
            state.status = true;
            state.msg = "Gallery section created successfully.";
            } else {
            console.log("gallerySections not an array");
            }
        })
        .addCase(createGallerySection.rejected, (state, action) => {
            state.status = false;
            state.error = action.payload as string;
        })

        // Edit gallery section
        .addCase(editGallerySection.fulfilled, (state, action: PayloadAction<any>) => {
            const { id, data } = action.payload;
            if (Array.isArray(state.gallerySections)) {
            const index = state.gallerySections.findIndex((section) => section.id === id);
            if (index !== -1) {
                state.gallerySections[index] = data;
            }
            state.status = true;
            state.msg = "Gallery section updated successfully.";
            } else {
            console.log("gallerySections not an array");
            }
        })
        .addCase(editGallerySection.rejected, (state, action) => {
            state.status = false;
            state.error = action.payload as string;
        });
    },
    });

    export const { resetStatus } = gallerySectionSlice.actions;
    export default gallerySectionSlice.reducer;
